import {
  FormControl,
  InputLabel,
  Button,
  Select,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Box,
  Autocomplete,
} from "@mui/material";
import Slider from "react-slick";
import Paper from "@mui/material/Paper";
import React, { useState, useEffect } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import fetchcity from "../../common/fetchcity";
import MenuItem from "@mui/material/MenuItem";
import { OrbitProgress } from "react-loading-indicators";
import toast from "react-hot-toast";

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Addfuelrequest = ({ setActiveItem }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const fuelTypes = JSON.parse(localStorage.getItem("catalogValues")).fuelType;
  delete fuelTypes.inverted;
  const token = localStorage.getItem("token");
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).resourceTypes;
  const [inputValues, setInputValues] = useState({});
  const [prefillImageData, setpreFillImageData] = useState(null);
  const [postfillImageData, setpostFillImageData] = useState(null);
  const [uploadBillCopy, setUploadBillCopy] = useState(null);
  const [vehicleDetails, setVehicleDetails] = useState(null);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState(null);
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [transactionImages, setTransactionImages] = useState([]);
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [transactionInput, setTransactionInput] = useState({});
  const [vehicleListings, setVehicleListings] = useState([]);
  const [errors, setErrors] = useState({});
  const [attachementsForExtra, setAttachementsForExtra] = useState([]);

  const modeofPayments = {
    fuelcard: "Fuel Card",
    cash: "Cash",
    cheque: "Cheque",
    upi: "UPI",
    netbanking: "Net Banking",
    creditcard: "Credit Card",
    debitcard: "Debit Card",
  };

  let transactionInputField = [
    {
      label: "Transaction ID",
      type: "number",
      value: "transactionId",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Charges",
      type: "number",
      value: "transactionCharges",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Amount",
      type: "number",
      value: "transactionAmount",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Remark",
      type: "text",
      value: "transactionRemark",
      valueType: "text",
      subCategory: [],
    },
    {
      label: "Transaction Mode",
      type: "text",
      value: "modeOfPayment",
      valueType: "dropdown",
      subCategory: Object.entries(modeofPayments).map(([value, item]) => ({
        value: value, // e.g., "cash"
        item: item, // e.g., "Cash"
      })),
    },
  ];

  const handleOpen = (type) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setTransactionInput({});
    // setTransactionDetails([]);
    setTransactionImages([]);
  };

  function createData(TransactionId, Amount, Charges, Payment, Image) {
    return {
      TransactionId,
      Amount,
      Charges,
      Payment,
      attachments: Image,
    };
  }

  const rows = (transactionDetails || []).map((item) =>
    createData(
      item?.transactionId || "-",
      item?.transactionAmount,
      item?.transactionCharges || "-",
      item?.modeOfPayment,
      item?.attachments || []
    )
  );

  const settings = {
    dots: true,
    infinite: prefillImageData?.length > 1, // only loop if more than one
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  const filledBy = {
    fleet: "Fleet",
    // customer: "Customer",
  };

  useEffect(() => {
    fetchcity().then((response) => {
      if (response) {
        setCities(response);
      }
    });
  }, []);

  const fuelMeterReading = [
    { value: "5%", item: 5 },
    { value: "10%", item: 10 },
    { value: "15%", item: 15 },
    { value: "20%", item: 20 },
    { value: "25%", item: 25 },
    { value: "30%", item: 30 },
    { value: "35%", item: 35 },
    { value: "40%", item: 40 },
    { value: "45%", item: 45 },
    { value: "50%", item: 50 },
    { value: "55%", item: 55 },
    { value: "60%", item: 60 },
    { value: "65%", item: 65 },
    { value: "70%", item: 70 },
    { value: "75%", item: 75 },
    { value: "80%", item: 80 },
    { value: "85%", item: 85 },
    { value: "90%", item: 90 },
    { value: "95%", item: 95 },
    { value: "100%", item: 100 },
  ];

  const defaultInputs = [
    // {
    //   id: 1,
    //   name: "City",
    //   type: "dropdown",
    //   value: "city",
    //   disable: true,
    //   subCategory: Object.entries(cities || {}).map(([key, value]) => ({
    //     value: value,
    //     item: key,
    //   })),
    // },
    // {
    //   id: 2,
    //   name: "Hub",
    //   type: "dropdown",
    //   value: "hub",
    //   disable: true,
    //   subCategory: [],
    // },
    {
      id: 3,
      name: "Search Vehicle By Registration No",
      type: "input",
      value: "searchVehcilebyRegistrationNo",
      disable: false,
      subCategory: vehicleListings.map((vehicle) => ({
        value:
          vehicle?.licensePlate +
          " - " +
          vehicle?.name +
          " - " +
          vehicle?.cityText,
        item: vehicle?.id,
      })),
    },
    {
      id: 4,
      name: "Vehicle Name",
      type: "input",
      value: "vehicleName",
      disable: true,
      subCategory: [],
    },
    {
      id: 5,
      name: "Vehicle Number",
      type: "input",
      value: "vehicleNumber",
      disable: true,
      subCategory: [],
    },
    {
      id: 6,
      name: "Booking Id",
      type: "input",
      value: "bookingId",
      disable: false,
      subCategory: [],
    },
    // {
    //   id: 6,
    //   name: "Filled By",
    //   type: "dropdown",
    //   value: "filledBy",
    //   disable: false,
    //   subCategory: Object.entries(filledBy).map(([key, value]) => ({
    //     value: value,
    //     item: key,
    //   })),
    // },
    // ...(inputValues?.filledBy === "Customer"
    //   ? [
    //       {
    //         id: 7,
    //         name: "Customer Name",
    //         type: "input",
    //         value: "customerName",
    //         disable: false,
    //         subCategory: [],
    //       },
    //       {
    //         id: 8,
    //         name: "Customer Booking ID",
    //         type: "input",
    //         value: "customerBookingId",
    //         disable: true,
    //         subCategory: [],
    //       },
    //       {
    //         id: 9,
    //         name: "Customer Email",
    //         type: "input",
    //         value: "customerEmail",
    //         disable: true,
    //         subCategory: [],
    //       },
    //     ]
    //   : []),
    // {
    //   id: 10,
    //   name: "Fuel Type",
    //   type: "dropdown",
    //   value: "fuelType",
    //   disable: false,
    //   subCategory: Object.entries(fuelTypes).map(([key, value]) => ({
    //     value: value,
    //     item: key,
    //   })),
    // },
    // {
    //   id: 11,
    //   name: "Liters Filled",
    //   type: "input",
    //   value: "liters",
    //   disable: false,
    //   subCategory: [],
    // },
    // {
    //   id: 12,
    //   name: "Odometer Reading in (KM)",
    //   type: "input",
    //   value: "odometerReading",
    //   disable: false,
    //   subCategory: [],
    // },
    // {
    //   id: 13,
    //   name: "Price Per Liter",
    //   type: "input",
    //   value: "pricePreLiter",
    //   disable: false,
    //   subCategory: [],
    // },
    // {
    //   id: 14,
    //   name: "Booking Id (Optional)",
    //   type: "input",
    //   value: "bookingId",
    //   disable: false,
    //   subCategory: [],
    // },
    // {
    //   id: 15,
    //   name: "Current Fuel Reading",
    //   type: "dropdown",
    //   value: "currentFuelReading",
    //   disable: false,
    //   subCategory: fuelMeterReading.map((reading) => ({
    //     value: reading.value,
    //     item: reading.item,
    //   })),
    // },
    // {
    //   id: 16,
    //   name: "Post Fuel Reading",
    //   type: "dropdown",
    //   value: "postFuelReading",
    //   disable: false,
    //   subCategory: fuelMeterReading.map((reading) => ({
    //     value: reading.value,
    //     item: reading.item,
    //   })),
    // },

    // {
    //   id: 17,
    //   name: "Amount",
    //   type: "input",
    //   value: "amount",
    //   disable: false,
    //   subCategory: [],
    // },
    // {
    //   id: 18,
    //   name: "Bill No",
    //   type: "input",
    //   value: "billNo",
    //   disable: false,
    //   subCategory: [],
    // },
    // {
    //   id: 19,
    //   name: "Description",
    //   type: "input",
    //   value: "description",
    //   disable: false,
    //   subCategory: [],
    // },
  ];

  const [formDefaultInputs, setFormDefaultInputs] = useState(
    defaultInputs.sort((a, b) => a.id - b.id)
  );

  const preFIllInputs = [
    {
      id: 1,
      name: "Current Odometer Reading in (KM)",
      type: "input",
      value: "odometerReading",
      disable: false,
      subCategory: [],
      allowOnlyNumbers: true,
    },
    {
      id: 2,
      name: "Current Fuel Reading",
      type: "dropdown",
      value: "currentFuelReading",
      disable: false,
      subCategory: fuelMeterReading.map((reading) => ({
        value: reading.value,
        item: reading.item,
      })),
    },
  ];

  const postFillInputs = [
    {
      id: 1,
      name: "Filled By",
      type: "dropdown",
      value: "filledBy",
      disable: false,
      subCategory: Object.entries(filledBy).map(([key, value]) => ({
        value: value,
        item: key,
      })),
    },
    {
      id: 2,
      name: "Fuel Type",
      type: "dropdown",
      value: "fuelType",
      disable: false,
      subCategory: Object.entries(fuelTypes).map(([key, value]) => ({
        value: value,
        item: key,
      })),
    },
    {
      id: 3,
      name: "Liters Filled",
      type: "input",
      value: "liters",
      disable: false,
      subCategory: [],
      allowOnlyNumbers: true,
    },
    {
      id: 4,
      name: "Price Per Liter",
      type: "input",
      value: "pricePreLiter",
      disable: false,
      subCategory: [],
      allowOnlyNumbers: true,
    },
    {
      id: 5,
      name: "Post Fuel Reading",
      type: "dropdown",
      value: "postFuelReading",
      disable: false,
      subCategory: fuelMeterReading.map((reading) => ({
        value: reading.value,
        item: reading.item,
      })),
    },
    {
      id: 6,
      name: "Amount",
      type: "input",
      value: "amount",
      disable: false,
      subCategory: [],
      allowOnlyNumbers: true,
    },
    {
      id: 7,
      name: "Bill No",
      type: "input",
      value: "billNo",
      disable: false,
      subCategory: [],
      allowOnlyNumbers: true,
    },
    {
      id: 8,
      name: "Description",
      type: "input",
      value: "description",
      disable: false,
      subCategory: [],
    },
  ];

  const [prefillFuelInputs, setPreFillFuelInputs] = useState(
    preFIllInputs.sort((a, b) => a.id - b.id)
  );
  const [postFillFuelInputs, setPOstFillFueleInputs] = useState(
    postFillInputs.sort((a, b) => a.id - b.id)
  );

  useEffect(() => {
    setFormDefaultInputs(defaultInputs);
  }, [inputValues?.filledBy, vehicleListings]);

  const postFuelRequests = async () => {
    let fuelType = Number(
      Object.keys(fuelTypes).find(
        (key) => fuelTypes[key] === inputValues?.fuelType
      )
    );

    const hubText = hubs?.find((item) => item?.id === hub)?.hubName;

    if (!prefillImageData || !postfillImageData || !uploadBillCopy) {
      return toast.error("Please Upload Images");
    }

    if (
      // inputValues.bookingId &&
      inputValues.vehicleName &&
      inputValues?.vehicleNumber &&
      transactionDetails?.length
    ) {
      const submitFuelRequest = async () => {
        const response = await fetch(`${apiUrl}/api/fuellogs`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: localStorage.getItem("token"),
          },
          body: JSON.stringify({
            vehicleId: vehicleDetails?.id,
            vehicleName: inputValues?.vehicleName,
            registrationNo: inputValues?.vehicleNumber,
            cityId: city,
            hubId: hub,
            hubText: hubText,
            cityText: cities[city],
            filledQunatity: inputValues?.liters,
            currentOdometer: inputValues?.currentFuelReading
              ? Number(inputValues?.currentFuelReading?.slice(0, -1))
              : null,
            preFillFuelReading: inputValues?.currentFuelReading
              ? Number(inputValues?.currentFuelReading?.slice(0, -1))
              : null,
            preFillFuelAttachments: JSON.stringify(prefillImageData),
            postFillFuelReading: inputValues?.postFuelReading
              ? Number(inputValues?.postFuelReading?.slice(0, -1))
              : null,
            postFillFuelAttachments: JSON.stringify(postfillImageData),
            amount: inputValues?.amount,
            fuelType: fuelType,
            currentFuelPrice: inputValues?.pricePreLiter,
            billNo: inputValues?.billNo || null,
            billAttachments: uploadBillCopy
              ? JSON.stringify(uploadBillCopy)
              : null,
            filledBy: inputValues?.filledBy || null,
            transactionList: transactionDetails,
            attachments: JSON.stringify(attachementsForExtra),
            bookingId : inputValues?.bookingId
          }),
        });

        const data = await response.json();

        if (data?.statusCode === "0100") {
          setInputValues({});
          setpostFillImageData(null);
          setpreFillImageData(null);
          setUploadBillCopy(null);
          setTransactionDetails([]);
          setTransactionInput({});
          setHubs(null);
          setCities(null);
          setActiveItem("View All");
          setAttachementsForExtra(null);
          localStorage.setItem("status", true);
          return "Fuel request submitted successfully";
        } else {
          throw new Error(
            data?.message || "Failed to submit fuel request please try again"
          );
        }
      };

      toast.promise(submitFuelRequest(), {
        loading: "Submitting fuel request...",
        success: (msg) => msg,
        error: (err) => err.message || "Submission failed",
      });
    } else if (!inputValues?.bookingId) {
      toast.error("Please fill the booking Id");
    } else if (!inputValues?.vehicleName || !inputValues?.vehicleNumber) {
      toast.error("Please fill Vehicle Details");
    } else if (!transactionDetails) {
      toast.error("Please fill in the transaction details");
    } else {
      toast.error("Please fill in all the details");
    }
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setHubs(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleInputValueChanges = (label, event) => {
    const value = event.target.value;
    const key = label?.value;

    if (key) {
      setInputValues((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const handleTransactionValueChanges = (label, event) => {
    const value = event.target.value;
    const key = label?.value;

    if (key) {
      setTransactionInput((prev) => ({
        ...prev,
        [key]: value === "" ? null : value,
        attachments: transactionImages,
        resourceType: resourceTypes?.inverted?.["fuelLogs"],
        transactionType: "debit",
      }));
    }
  };

  const handleUploadImage = async (event, imageUploadedTo) => {
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "pettyCash");
    formData.append("fileTags", "vehicle");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        if (imageUploadedTo === "Pre-Fill Fuel Gauge Image") {
          setpreFillImageData(data?.uploaded);
        } else if (imageUploadedTo === "Upload Bill Copy") {
          setUploadBillCopy(data?.uploaded);
        } else if (imageUploadedTo === "Post-Fill Fuel Gauge Image") {
          setpostFillImageData(data?.uploaded);
        } else if (imageUploadedTo === "Attachements") {
          setAttachementsForExtra(data?.uploaded);
        } else {
          setTransactionImages(data?.uploaded);
        }
        // setImage(data?.uploaded[0]?.url);
        // setLoading(false);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching upload image in add fuel:", error);
    }
  };

  const getVechileListings = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=500&offset=0&hubId=${id}`,
        {
          method: "GET",
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleListings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const handleHubChange = async (event) => {
    setHub(event.target.value);
    await getVechileListings(event.target.value);
  };

  const handleCityChange = async (event) => {
    setHub(null);
    const value = event.target.value;
    setCity(value);
    const hubData = await getHubNames(value);
    if (hubData?.entities?.rows?.[0]) {
      const firstHubId = hubData.entities.rows[0].id;
      setHub(firstHubId);
      await getVechileListings(firstHubId);
    }
  };

  return (
    <>
      {open && (
        <Modal
          keepMounted
          open={open}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <div className="grid grid-cols-2 gap-4">
              {transactionInputField.map((field, idx) =>
                field.valueType === "text" ? (
                  <TextField
                    key={idx}
                    fullWidth
                    label={field.label}
                    variant="outlined"
                    type={field.valueType}
                    onChange={(event) => {
                      handleTransactionValueChanges(field, event);
                    }}
                  />
                ) : (
                  <FormControl fullWidth>
                    <InputLabel id="drop-label">{field?.label}</InputLabel>
                    <Select
                      key={idx}
                      labelId="drop-label"
                      value={transactionInput[field.value] || ""}
                      onChange={(event) =>
                        handleTransactionValueChanges(field, event)
                      }
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200, // Limits dropdown height (optional)
                          },
                        },
                      }}
                      label={field?.label}
                    >
                      {field?.subCategory?.map((option, index) => (
                        <MenuItem
                          sx={{
                            minHeight: 24, // Smaller height
                            paddingY: 0.5, // Compact vertical padding
                            fontSize: "0.8rem", // Smaller font (optional)
                          }}
                          key={index}
                          value={option.value}
                        >
                          {option.item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )
              )}

              <div className="bg-white md:col-span-2 border rounded-xl shadow-md p-4">
                {loading ? (
                  <div className="flex flex-col items-center justify-center">
                    <OrbitProgress
                      variant="spokes"
                      color="#557af2"
                      size="medium"
                      text="Image Uploading"
                      textColor="#aeb7fb"
                    />
                  </div>
                ) : transactionImages.length === 1 ? (
                  <img
                    src={transactionImages[0]?.url}
                    alt="Preview"
                    className="w-full h-64 object-contain rounded"
                  />
                ) : (
                  <Slider {...settings}>
                    {transactionImages.map((img, idx) => (
                      <div key={idx}>
                        <img
                          src={img?.url}
                          alt={`Preview ${idx}`}
                          className="w-full h-64 object-contain rounded"
                        />
                      </div>
                    ))}
                  </Slider>
                )}

                <div className="mt-4">
                  <h1 className="text-center">Transaction Images</h1>
                  <div className="flex justify-center mt-4">
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                    >
                      Upload File
                      <VisuallyHiddenInput
                        type="file"
                        // multiple
                        onChange={handleUploadImage}
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex mt-6 mx-auto gap-4">
              <Button
                onClick={() => {
                  setTransactionDetails((prev) => [
                    ...prev,
                    {
                      transactionId: transactionInput.transactionId || "0",
                      transactionCharges:
                        transactionInput.transactionCharges || "0",
                      transactionAmount:
                        transactionInput.transactionAmount || "-",
                      transactionRemark:
                        transactionInput.transactionRemark || "-",
                      modeOfPayment: transactionInput.modeOfPayment || "-",
                      attachments: transactionImages,
                      resourceType: transactionInput.resourceType,
                      transactionType: "debit",
                    },
                  ]);

                  setTransactionInput({});
                  setTransactionImages([]);
                  setOpen(false);
                }}
                variant="contained"
              >
                Submit
              </Button>

              <Button
                onClick={() => {
                  // setTransactionDetails([]);
                  setOpen(false);
                  setTransactionImages([]);
                  setTransactionInput({});
                }}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      <div className="h-full md:min-h-screen p-4">
        <div className="my-4 text-xl md:text-2xl font-bold">
          <h1>Add Fuel Details</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:mt-10">
          <FormControl fullWidth>
            <InputLabel id="city-label">City</InputLabel>
            <Select
              labelId="city-label"
              value={city}
              onChange={handleCityChange}
              label="City"
            >
              {cities &&
                Object.entries(cities).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="hub-label">Hub</InputLabel>
            <Select
              onChange={handleHubChange}
              labelId="hub-label"
              autoWidth
              label="Hub"
            >
              {hubs ? (
                hubs.map((item, index) => (
                  <MenuItem key={index} value={item?.id}>
                    {item?.hubName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">
                  <em>Select City First</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>

          {formDefaultInputs?.map((label, index) => {
            return label?.type === "input" ? (
              <>
                {label?.name === "Search Vehicle By Registration No" ? (
                  <Autocomplete
                    fullWidth
                    freeSolo
                    options={vehicleListings}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") {
                        return option;
                      }
                      if (option && typeof option === "object") {
                        const licensePlate = option.licensePlate || "";
                        const name = option.name || "";
                        const cityText = option.cityText || "";
                        return `${licensePlate} - ${name} - ${cityText}`.trim();
                      }
                      return "";
                    }}
                    filterOptions={(options, { inputValue }) => {
                      return options.filter((option) =>
                        (option?.licensePlate || "")
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      );
                    }}
                    onInputChange={(event, newInputValue) => {
                      handleInputValueChanges(label, {
                        target: { value: newInputValue },
                      });
                    }}
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue !== "string") {
                        // set selected vehicle data
                        setVehicleDetails(newValue);

                        setInputValues((prev) => ({
                          ...prev,
                          [label.value]: newValue.licensePlate,
                          vehicleName: newValue.name || "",
                          vehicleNumber: newValue.licensePlate || "",
                          city: newValue.cityText || "",
                          cityId: newValue.cityId || null,
                          hub:
                            hubs?.find((h) => h.id === newValue.hubId)
                              ?.hubName || "",
                          hubId: newValue.hubId || null,
                        }));
                      } else if (typeof newValue === "string") {
                        handleInputValueChanges(label, {
                          target: { value: newValue },
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={label?.name}
                        InputLabelProps={{ shrink: true }}
                        autoComplete="off"
                      />
                    )}
                  />
                ) : (
                  <TextField
                    key={index}
                    InputLabelProps={{ shrink: true }}
                    label={label?.name}
                    autoComplete="off"
                    value={inputValues[label.value] || ""}
                    onChange={(event) => handleInputValueChanges(label, event)}
                    fullWidth
                    InputProps={{
                      readOnly: label?.disable,
                    }}
                  />
                )}
              </>
            ) : (
              <FormControl fullWidth>
                <InputLabel id="drop-label">{label?.name}</InputLabel>
                <Select
                  key={index}
                  labelId="drop-label"
                  value={inputValues[label.value] || ""}
                  onChange={(event) => handleInputValueChanges(label, event)}
                  label={label?.name}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 200, // Limits dropdown height (optional)
                      },
                    },
                  }}
                >
                  {label?.subCategory?.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item?.value}
                      sx={{
                        minHeight: 24, // Smaller height
                        paddingY: 0.5, // Compact vertical padding
                        fontSize: "0.8rem", // Smaller font (optional)
                      }}
                    >
                      {item?.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          })}
        </div>

        <div>
          <div className="my-8 text-xl md:text-2xl font-bold">
            <h1>Pre Fuel Details</h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:mt-10">
            {prefillFuelInputs?.map((label, index) => {
              return label?.type === "input" ? (
                <>
                  <TextField
                    key={index}
                    InputLabelProps={{ shrink: true }}
                    label={label?.name}
                    autoComplete="off"
                    value={inputValues[label.value] || ""}
                    onChange={(event) => handleInputValueChanges(label, event)}
                    fullWidth
                    error={!!errors[label.value]}
                    helperText={errors[label.value]}
                    InputProps={{
                      readOnly: label?.disable,
                    }}
                    onKeyDown={(e) => {
                      if (label.allowOnlyNumbers) {
                        const allowedKeys = [
                          "Backspace",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                          "Delete",
                          ".",
                        ];
                        const isNumber = /^[0-9]$/.test(e.key);
                        if (!isNumber && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }
                    }}
                  />
                </>
              ) : (
                <FormControl fullWidth>
                  <InputLabel id="drop-label">{label?.name}</InputLabel>
                  <Select
                    key={index}
                    labelId="drop-label"
                    value={inputValues[label.value] || ""}
                    onChange={(event) => handleInputValueChanges(label, event)}
                    label={label?.name}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200, // Limits dropdown height (optional)
                        },
                      },
                    }}
                  >
                    {label?.subCategory?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item?.value}
                        sx={{
                          minHeight: 24, // Smaller height
                          paddingY: 0.5, // Compact vertical padding
                          fontSize: "0.8rem", // Smaller font (optional)
                        }}
                      >
                        {item?.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              );
            })}
          </div>

          <div className="p-4 md:col-span-6 flex flex-col items-center border-4 mt-4 border-gray rounded-lg">
            <h1 className="mb-4 text-lg font-semibold">
              Pre-Fill Fuel Gauge Image
            </h1>
            {loading ? (
              <div className="flex flex-col items-center justify-center">
                <OrbitProgress
                  variant="spokes"
                  color="#557af2"
                  size="medium"
                  text="Image Uploading"
                  textColor="#aeb7fb"
                />
              </div>
            ) : (
              <>
                <div className="max-w-xs w-full mb-4">
                  {prefillImageData?.length > 1 ? (
                    <Slider {...settings}>
                      {prefillImageData.map((img, idx) => (
                        <div key={idx}>
                          <img
                            src={img?.url}
                            alt={`Preview ${idx}`}
                            className="w-full h-64 object-cover rounded"
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    prefillImageData?.[0] && (
                      <img
                        src={prefillImageData[0]?.url}
                        alt="Preview"
                        className="w-full h-64 object-cover rounded"
                      />
                    )
                  )}
                </div>

                {
                  <div className="mt-4">
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                    >
                      Upload File
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(event) => {
                          handleUploadImage(event, "Pre-Fill Fuel Gauge Image");
                        }}
                        // multiple
                      />
                    </Button>
                  </div>
                }
              </>
            )}
          </div>
        </div>

        <div>
          <div className="my-8 text-xl md:text-2xl font-bold">
            <h1>Add Transaction Details</h1>
          </div>

          {transactionDetails.length > 0 && (
            <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="dynamic table"
                >
                  <TableHead>
                    <TableRow className="bg-gray-100">
                      {/* Dynamically render headers */}
                      {rows.length > 0 &&
                        Object.keys(rows[0]).map((key) => (
                          <TableCell key={key}>{key}</TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow key={index}>
                        {Object.entries(row).map(([key, value], idx) => (
                          <TableCell key={idx}>
                            {key === "attachments" && value ? (
                              <div
                                title="image"
                                className="flex gap-4 items-center cursor-pointer"
                              >
                                {value.map((item, index) => (
                                  <div
                                    key={index}
                                    className="items-center gap-2"
                                  >
                                    <img
                                      src={item?.url}
                                      alt="Attachment"
                                      className="w-8 h-8 object-contain"
                                    />
                                  </div>
                                ))}
                              </div>
                            ) : (
                              value
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>

        <div className="mt-6 items-center mx-auto">
          <Button onClick={() => handleOpen("transaction")} variant="contained">
            Add Transaction Details
          </Button>
        </div>

        <div>
          <div className="my-8 text-xl md:text-2xl font-bold">
            <h1>Post Fuel & Bill Details</h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:mt-10">
            {postFillFuelInputs?.map((label, index) => {
              return label?.type === "input" ? (
                <>
                  <TextField
                    key={index}
                    InputLabelProps={{ shrink: true }}
                    label={label?.name}
                    autoComplete="off"
                    value={inputValues[label.value] || ""}
                    onChange={(event) => handleInputValueChanges(label, event)}
                    fullWidth
                    error={!!errors[label.value]}
                    helperText={errors[label.value]}
                    InputProps={{
                      readOnly: label?.disable,
                    }}
                    onKeyDown={(e) => {
                      if (label.allowOnlyNumbers) {
                        const allowedKeys = [
                          "Backspace",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                          "Delete",
                          ".",
                        ];
                        const isNumber = /^[0-9]$/.test(e.key);
                        if (!isNumber && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }
                    }}
                  />
                </>
              ) : (
                <FormControl fullWidth>
                  <InputLabel id="drop-label">{label?.name}</InputLabel>
                  <Select
                    key={index}
                    labelId="drop-label"
                    value={inputValues[label.value] || ""}
                    onChange={(event) => handleInputValueChanges(label, event)}
                    label={label?.name}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200, // Limits dropdown height (optional)
                        },
                      },
                    }}
                  >
                    {label?.subCategory?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item?.value}
                        sx={{
                          minHeight: 20, // Smaller height
                          paddingY: 0.5, // Compact vertical padding
                          fontSize: "0.8rem", // Smaller font (optional)
                        }}
                      >
                        {item?.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              );
            })}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            <div className="p-4 md:col-span-1 flex flex-col items-center border-4 border-gray rounded-lg">
              <h1 className="mb-4 text-lg font-semibold">
                Post-Fill Fuel Gauge Image
              </h1>
              {loading ? (
                <div className="flex flex-col items-center justify-center">
                  <OrbitProgress
                    variant="spokes"
                    color="#557af2"
                    size="medium"
                    text="Image Uploading"
                    textColor="#aeb7fb"
                  />
                </div>
              ) : (
                <>
                  <div className="max-w-xs w-full mb-4">
                    {postfillImageData?.length > 1 ? (
                      <Slider {...settings}>
                        {postfillImageData.map((img, idx) => (
                          <div key={idx}>
                            <img
                              src={img?.url}
                              alt={`Preview ${idx}`}
                              className="w-full h-64 object-cover rounded"
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      postfillImageData?.[0] && (
                        <img
                          src={postfillImageData[0]?.url}
                          alt="Preview"
                          className="w-full h-64 object-cover rounded"
                        />
                      )
                    )}
                  </div>

                  {
                    <div className="mt-4">
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                      >
                        Upload File
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(event) => {
                            handleUploadImage(
                              event,
                              "Post-Fill Fuel Gauge Image"
                            );
                          }}
                          // multiple
                        />
                      </Button>
                    </div>
                  }
                </>
              )}
            </div>

            <div className="p-4 md:col-span-1 flex flex-col items-center border-4 border-gray rounded-lg">
              <h1 className="mb-4 text-lg font-semibold">Upload Bill Copy</h1>
              {loading ? (
                <div className="flex flex-col items-center justify-center">
                  <OrbitProgress
                    variant="spokes"
                    color="#557af2"
                    size="medium"
                    text="Image Uploading"
                    textColor="#aeb7fb"
                  />
                </div>
              ) : (
                <>
                  <div className="max-w-xs w-full mb-4">
                    {uploadBillCopy?.length > 1 ? (
                      <Slider {...settings}>
                        {uploadBillCopy.map((img, idx) => (
                          <div key={idx}>
                            <img
                              src={img?.url}
                              alt={`Preview ${idx}`}
                              className="w-full h-64 object-cover rounded"
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      uploadBillCopy?.[0] && (
                        <img
                          src={uploadBillCopy[0]?.url}
                          alt="Preview"
                          className="w-full h-64 object-cover rounded"
                        />
                      )
                    )}
                  </div>

                  {
                    <div className="mt-4">
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                      >
                        Upload File
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(event) => {
                            handleUploadImage(event, "Upload Bill Copy");
                          }}
                          // multiple
                        />
                      </Button>
                    </div>
                  }
                </>
              )}
            </div>
          </div>
        </div>

        <div className="p-4 flex flex-col my-4 items-center border-4 border-gray rounded-lg">
          <h1 className="mb-4 text-lg font-semibold">Attachments</h1>
          {loading ? (
            <div className="flex flex-col items-center justify-center">
              <OrbitProgress
                variant="spokes"
                color="#557af2"
                size="medium"
                text="Image Uploading"
                textColor="#aeb7fb"
              />
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {attachementsForExtra &&
                  attachementsForExtra?.map((item, index) => (
                    <div className="my-6" key={index}>
                      {item?.fileExt?.includes(".jpg") ||
                      item?.fileExt?.includes(".webp") ||
                      item?.fileExt?.includes(".jpeg") ||
                      item?.fileExt?.includes(".png") ? (
                        <img
                          src={item?.url ? item?.url : item?.path}
                          alt="Preview"
                          className="w-full h-72 mt-2 object-contain rounded"
                        />
                      ) : item?.fileExt?.includes(".csv") ||
                        item?.fileExt?.includes(".html") ||
                        item?.fileExt?.includes(".pdf") ||
                        item?.fileExt?.includes(".docx") ||
                        item?.fileExt?.includes(".doc") ? (
                        <>
                          <iframe
                            src={`https://docs.google.com/gview?url=${item?.url}&embedded=true`}
                            width="100%"
                            height="300px"
                          />
                        </>
                      ) : item?.fileExt?.includes(".mp4") ||
                        item?.fileExt?.includes(".mov") ||
                        item?.fileExt?.includes(".mkv") ? (
                        <>
                          <video
                            className="h-72"
                            controls
                            poster={item?.fileName}
                          >
                            <source src={item?.url} type="video/mp4" />
                          </video>
                        </>
                      ) : (
                        <p className="text-gray-500 text-center mt-4 italic">
                          No image available
                        </p>
                      )}
                    </div>
                  ))}
              </div>
              {/* <div className="max-w-xs w-full mb-4">
                {attachementsForExtra?.length > 1 ? (
                  <Slider {...settings}>
                    {attachementsForExtra.map((img, idx) => (
                      <div key={idx}>
                        <img
                          src={img?.url}
                          alt={`Preview ${idx}`}
                          className="w-full h-64 object-cover rounded"
                        />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  attachementsForExtra?.[0] && (
                    <img
                      src={attachementsForExtra[0]?.url}
                      alt="Preview"
                      className="w-full h-64 object-cover rounded"
                    />
                  )
                )}
              </div> */}

              {
                <div className="mt-4">
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                  >
                    Upload File
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => {
                        handleUploadImage(event, "Attachements");
                      }}
                      multiple
                    />
                  </Button>
                </div>
              }
            </>
          )}
        </div>

        <div className="flex justify-center items-center mt-6">
          <button
            onClick={() => {
              postFuelRequests();
            }}
            className="bg-blue-600 text-white px-6 py-2 rounded-md font-bold hover:bg-blue-800 transition text-sm md:text-base"
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default Addfuelrequest;
